import {inject, Injectable} from '@angular/core';
import {NoteFilesModalApiService} from "./note-files-modal-api.service";
import {AttachNoteFileParams, NoteFilesData} from "../types/note-files-modal.types";
import {PreviewFileUrlsStateService} from "../../../../../../../core/services/preview-file-urls-state.service";
import {NoteFilesStateService} from "./note-files-state.service";

@Injectable({
  providedIn: 'root'
})
export class NoteFilesModalService {
  private noteFilesModalApiService: NoteFilesModalApiService = inject(NoteFilesModalApiService);
  private noteFilesStateService: NoteFilesStateService = inject(NoteFilesStateService);
  private previewFileUrlsStateService: PreviewFileUrlsStateService = inject(PreviewFileUrlsStateService);

  public getFileUrls(): void {
    const filesState = this.noteFilesStateService.noteFilesState();
    if (!filesState) { return; }

    this.previewFileUrlsStateService.setPreviewFileUrlsState({
      'NOTES_FILE': filesState.map(file => file.file)
    });
  }

  public getNoteFiles(noteId: number): Promise<Array<NoteFilesData>> {
    return new Promise((resolve, reject) => {
      this.noteFilesModalApiService.getNoteFiles(noteId).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public attachNoteFile(attachNoteFileParams: AttachNoteFileParams): Promise<NoteFilesData> {
    return new Promise((resolve, reject) => {
      this.noteFilesModalApiService.attachNoteFile(attachNoteFileParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public deleteNoteFile(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.noteFilesModalApiService.deleteNoteFile(id).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
